import React from "react";

// Models
import { QuoteProcurementPartInfoResponse } from "@/main/models/response";

// Components
import { RenderPartInformation, RenderQuoteItemInformation } from "./quoteProcurementPartInfo";

// Utils
import { isNullUndefined, isNullUndefinedEmpty } from "@/main/services/utils";
import { handleKeyActivate } from "@/main/services/utils";

interface QuoteProcurementPartInfoRowProps {
	data: QuoteProcurementPartInfoResponse;
	rowStyleContainer?: React.CSSProperties;
	isHyperLink?: boolean;
	onClick?: () => void;
}

export function renderPartInfoRow({
	partName,
	partPosition,
	quoteItemDescription,
	quoteItemPartNumber,
	notes,
}: QuoteProcurementPartInfoResponse) {
	if (isNullUndefinedEmpty(partName) && isNullUndefinedEmpty(partPosition)) {
		return <></>;
	}

	if (
		!isNullUndefinedEmpty(quoteItemDescription) ||
		!isNullUndefinedEmpty(quoteItemPartNumber) ||
		!isNullUndefinedEmpty(notes)
	)
		return (
			<>
				&nbsp;&nbsp;{"("}
				<RenderPartInformation partName={partName} partPosition={partPosition} />
				{")"}
			</>
		);

	return <RenderPartInformation partName={partName} partPosition={partPosition} />;
}

export default function QuoteProcurementPartInfoRow({
	data,
	rowStyleContainer,
	isHyperLink = false,
	onClick,
}: QuoteProcurementPartInfoRowProps) {
	const style = !isNullUndefined(rowStyleContainer) ? rowStyleContainer : {};

	const hyperLinkStyle: React.CSSProperties = isHyperLink
		? {
				cursor: "pointer",
				color: "#1976d2",
				textDecoration: "underline",
			}
		: {};

	const combinedStyle = { ...style, ...hyperLinkStyle };

	const { quoteItemDescription, quoteItemPartNumber, partType, notes, tireInfo, glassInfo, idPartType, partName } =
		data;

	return (
		<div
			role={isHyperLink ? "button" : undefined}
			tabIndex={isHyperLink ? 0 : undefined}
			onKeyDown={isHyperLink ? handleKeyActivate(() => onClick?.()) : undefined}
			className="d-flex"
			style={combinedStyle}
			onClick={isHyperLink ? onClick : undefined}
		>
			<RenderQuoteItemInformation
				quoteItemDescription={quoteItemDescription}
				quoteItemPartNumber={quoteItemPartNumber}
				partType={partType}
				notes={notes}
				tireInfo={tireInfo}
				glassInfo={glassInfo}
				idPartType={idPartType}
				partName={partName}
			/>

			{renderPartInfoRow(data)}
		</div>
	);
}
